var App = App || {};

App.WidgetYextFaq = (function ($) {
    'use strict';

    function Init() {
        const selector = $(".widget.widget-faq-yext");

        if (!selector.length) {
            return;
        }

        selector.each(function () {
            const $widget = $(this);
            const $accordion = $widget.find(".accordion");
            const accordionId = $accordion.attr("id");

            if (!accordionId) {
                return;
            }

            const $button = $widget.find(`button[aria-controls='${accordionId}']`);

            $button.on("click", function () {
                const isPanelExpanded = $button.attr("aria-expanded") === "true";
                $button.attr("aria-expanded", isPanelExpanded ? "false" : "true");
                $button.text(isPanelExpanded ? "View More" : "View Less");

                if (!isPanelExpanded) {
                    $accordion
                        .find(".accordion-item.d-none")
                        .addClass("accordion-item-conditional")
                        .removeClass("d-none");
                }
                else {
                    $accordion
                        .find(".accordion-item.accordion-item-conditional")
                        .removeClass("accordion-item-conditional")
                        .addClass("d-none");
                }
            });
        });
    }


    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.WidgetYextFaq.Init();
});